import { Pipe, PipeTransform } from '@angular/core';

import { colorMappingTemp } from '../constants/constants';

@Pipe({ name: 'colorMappingTemp' })
export class ColorMappingTempPipe implements PipeTransform {
  transform(value: number) {
    return colorMappingTemp(value);
  }
}
